import { storage } from '@mercadoni/sinister/dist/cjs/shared'

const storageMiddleware = (type: string) => {
  return storage(type)
}

export default storageMiddleware
